module.exports = __webpack_public_path__ + "static/media/TaskStatusCompleted.b5976b08.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/TaskStatusCompleted.mp3
// module id = 2827
// module chunks = 0